import React, { useState } from "react";
import { useRef } from "react";
import { ImageCropper, Modal } from "../../Components";
import { Pencil } from "lucide-react";

export default function MyProfileUploader({
  setShowConfirmInfModal,
  form,
  croppedImage,
  setCroppedImage,
}) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const fileInputRef = useRef(null);

  const onSelectFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setSelectedImage(reader.result);
      };
      setShowUploadModal(true);
    }
  };

  // const resetCroppedAndSelectedImage = () => {
  //   setSelectedImage(null);
  //   setShowConfirmInfModal(true);
  //   fileInputRef.current.value = "";
  // };

  return (
    <>
      <div className="relative inline-block">
        <div className="relative group">
          {/* Show image or placeholder */}
          {croppedImage || form.profile_img_url !== "" ? (
            <img
              alt="Img"
              className="w-32 h-32 mt-1 rounded-full object-cover border-4 border-white shadow-lg"
              src={
                croppedImage && croppedImage !== ""
                  ? croppedImage
                  : form.profile_img_url && form.profile_img_url !== ""
                  ? form.profile_img_url
                  : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
              }
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
              }}
            />
          ) : (
            <div className="w-32 h-32 mt-1 rounded-full border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer">
              <svg
                className="w-8 h-8 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </div>
          )}

          <label
            htmlFor="fileInput"
            className="absolute bottom-2 right-2 w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white cursor-pointer hover:bg-green-700 transition-colors shadow-lg group-hover:scale-110 transform duration-200"
          >
            <Pencil size={16} />
          </label>
        </div>

        <input
          title=" "
          type="file"
          accept="image/jpeg,image/gif,image/png"
          ref={fileInputRef}
          className="hidden"
          onChange={onSelectFile}
          id="fileInput"
        />

        {form.profile_img === "" && (
          <div className="mt-3 text-sm text-red-600 bg-red-50 px-3 py-2 rounded-lg border border-red-200">
            Please upload file
          </div>
        )}
      </div>

      {/* Image cropper modal */}
      {selectedImage && showUploadModal && (
        <Modal
          addClass="max-w-2xl rounded-xl shadow-xl bg-white"
          close={() => {
            setShowUploadModal(false);
            setSelectedImage(null);
          }}
        >
          <div className="p-6">
            <ImageCropper
              imageUrl={selectedImage}
              setImageSrc={setSelectedImage}
              setCroppedImage={setCroppedImage}
              setSelectedImage={setSelectedImage}
            />
          </div>
        </Modal>
      )}
    </>
  );
}
